import { Button } from "react-bootstrap";
import styled from "styled-components";

export const TableActionButtonDelete = styled(Button)`
  background-color: #ff4d4d;
  border-color: #ff4d4d;
  color: white;
  border-color: #ff4d4d;
  padding: 0.2rem 0.4rem;
  &:hover,
  &:focus,
  &:active {
    background-color:#ff8080 !important;
    border-color: #ff8080 !important;
  }

  transition: all 0.3s ease;
`;